import { Mail } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function Careers() {
  return (
    <div data-testid="careers-page">
      <section className="max-w-5xl mx-auto px-6 lg:px-10 pt-20 lg:pt-28 pb-24 lg:pb-32">
        <div className="text-xs uppercase tracking-[0.18em] text-orange-600 font-semibold mb-4 mm-fade-up">
          Careers
        </div>
        <h1
          data-testid="careers-heading"
          className="mm-fade-up mm-delay-1 font-heading text-4xl sm:text-5xl lg:text-6xl font-light tracking-tight text-slate-900 max-w-3xl leading-[1.05]"
        >
          No open positions <span className="font-medium">right now.</span>
        </h1>
        <p className="mm-fade-up mm-delay-2 mt-6 text-base sm:text-lg text-slate-600 leading-relaxed max-w-2xl">
          We're always interested in meeting exceptional engineers, architects, and specialists. If you'd like to be considered for future opportunities, send your CV and we'll be in touch when a role matches your strengths.
        </p>

        <div className="mm-fade-up mm-delay-3 mt-10 border border-slate-200 rounded-xl p-8 lg:p-10 bg-slate-50">
          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-6 sm:gap-8 justify-between">
            <div>
              <div className="text-xs uppercase tracking-[0.18em] text-slate-500 font-medium mb-2">
                Send your CV
              </div>
              <a
                href="mailto:careers@t3partner.in?subject=Future opportunity — CV submission"
                data-testid="careers-email-link"
                className="font-heading text-2xl sm:text-3xl font-medium text-slate-900 hover:text-orange-600 transition-colors"
              >
                careers@t3partner.in
              </a>
            </div>
            <Button
              asChild
              data-testid="careers-email-cta"
              className="bg-blue-600 hover:bg-blue-700 text-white rounded-md h-12 px-7 text-sm font-semibold tracking-wide"
            >
              <a href="mailto:careers@t3partner.in?subject=Future opportunity — CV submission">
                <Mail className="mr-2" size={16} /> Email us your CV
              </a>
            </Button>
          </div>
        </div>
      </section>
    </div>
  );
}
